import Mission from '../../missions/mission';
import DeploymentWeeks from '../../organization/deployment-week';
import Organization from '../../organization/organization';

export interface OrganizationDataReport {
  deploymentWeeks: DeploymentWeeks[];
  organization: Organization;
}

interface ReportDataSet {
  id: string;
  name: string;
  data: OrganizationDataReport | Mission[];
}

export const isOrganizationReportData = (
  data: OrganizationDataReport | Mission[],
): data is OrganizationDataReport => {
  return 'deploymentWeeks' in data && 'organization' in data;
};

export const isMissionsReportData = (
  data: OrganizationDataReport | Mission[],
): data is Mission[] => {
  return !('deploymentWeeks' in data) && !('organization' in data);
};

export default ReportDataSet;
